import HeaderContainer from "src/components/containers/HeaderContainer";
import { useInsideModal } from "src/modals";
import GlobalModal from "src/modals/configs/GlobalModal";
import { paddingMedium } from "src/styles/spacing";
import SaveTutorialModalContent from "./components/SaveTutorialModalContent";

const SaveTutorialModal = () => {
	const { closeSelf, props } = useInsideModal<GlobalModal["SaveTutorialModal"]>();
	return (
		<HeaderContainer
			exitVariant="Cancel"
			variant="Modal"
			onExit={closeSelf}
			headerText="How to save"
			safeAreaProps={{
				style: {
					paddingBottom: paddingMedium,
				},
			}}
		>
			<SaveTutorialModalContent {...props} closeSelf={closeSelf} />
		</HeaderContainer>
	);
};
export default SaveTutorialModal;
